export const parse = (address) => {
  const parsed = address;
  if (!address.city) parsed.city = address.municipality;
  // next line converts nil values to empty string
  return Object
    .entries(address)
    .reduce((acc, [key, value]) => ({ ...acc, [key]: value || '' }), {});
};
